import { render, staticRenderFns } from "./spejjzt.vue?vue&type=template&id=40633ddc&scoped=true&"
import script from "./spejjzt.vue?vue&type=script&lang=js&"
export * from "./spejjzt.vue?vue&type=script&lang=js&"
import style0 from "./spejjzt.vue?vue&type=style&index=0&id=40633ddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40633ddc",
  null
  
)

export default component.exports